/**
 * WorkspaceStep — the three visible steps of the pre-analysis flow
 * (scegli gli ETF → imposta i pesi → avvia l'analisi).
 *
 * Phase 5: the workspace used to be a stack of cards with no stated order. The
 * step is announced by a number AND by a word ("Completato"), never by colour
 * alone, and the section is a plain landmark so screen readers get the same
 * structure the eye gets.
 */
import { Check } from "lucide-react";

export function WorkspaceStep({ step, title, description, done = false, action, testId, children }) {
  return (
    <section data-testid={testId} className="min-w-0">
      <header className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1 mb-3">
        <div className="flex items-baseline gap-3 min-w-0">
          <span
            aria-hidden="true"
            className={`flex items-center justify-center w-7 h-7 shrink-0 rounded-full border text-sm font-semibold tabular
                        ${done
                          ? "border-brand-border bg-brand-subtle/60 text-brand-accent"
                          : "border-line-strong text-content-secondary"}`}
          >
            {done ? <Check className="w-4 h-4" /> : step}
          </span>
          <div className="min-w-0">
            <h2 className="text-base md:text-lg font-semibold text-content leading-tight">
              <span className="sr-only">{`Passo ${step}: `}</span>
              {title}
              {done && (
                <span
                  data-testid={testId ? `${testId}-done` : undefined}
                  className="ml-2 text-label uppercase tracking-wide text-content-muted"
                >
                  Completato
                </span>
              )}
            </h2>
            {description && (
              <p className="text-sm text-content-muted mt-0.5">{description}</p>
            )}
          </div>
        </div>
        {action}
      </header>
      <div className="sm:pl-10">{children}</div>
    </section>
  );
}

export default WorkspaceStep;
